
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import FlexMessageComponents from '@/components/common/flex-message/FlexMessageComponents.vue'
import { IFlexMessageBubble } from '@/utils/types'
import FlexMessageTreeNodes from '@/components/common/flex-message/FlexMessageTreeNodes.vue'
import debounce from 'quasar/src/utils/debounce.js';

@Options({
  components: { FlexMessageTreeNodes, FlexMessageComponents },
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class FlexMessageBubble extends Vue {
  @Prop()
  bubbleMessage!: IFlexMessageBubble

  @Prop()
  isChild!: boolean

  @Prop()
  bubbleIndex!: number

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  listNode: string[] = []

  get directionClass() {
    if (this.bubbleMessage.direction === 'rtl') {
      return 'fxRTL'
    }
    return 'fxLTR'
  }

  get sizeClass() {
    if (this.bubbleMessage.size === 'giga') {
      return 'LyGi'
    } else if (this.bubbleMessage.size === 'kilo') {
      return 'LyKi'
    } else if (this.bubbleMessage.size === 'hecto') {
      return 'LyHe'
    } else if (this.bubbleMessage.size === 'deca') {
      return 'LyDe'
    } else if (this.bubbleMessage.size === 'micro') {
      return 'LyMi'
    } else if (this.bubbleMessage.size === 'nano') {
      return 'LyNa'
    }
    return 'LyMe'
  }

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  initListNode(path) {
    this.listNode.push(path)
  }

  private debouncedListNode = debounce(() => {
    this.$emit('initListNode', this.listNode)
  }, 500)

  @Watch('listNode', { deep: true, immediate: true })
  lisNodeChanged() {
    this.debouncedListNode()
  }

  mounted() {
    if (!this.isChild) {
      this.listNode.unshift(this.bubbleIndex + '')
    }
  }
}
